// extracted by mini-css-extract-plugin
export default {"fake-disabled-link":"actions-module_fake-disabled-link_kRRH8XMD","fake-disabled-button":"actions-module_fake-disabled-button_W3t0wkNt"};